import RetrieveAccessCode from '../../../components/sections/osb-v3/retrieve-access-code/retrieve-access-code';

export function RetrieveAccessCodePageView() {
    return (
        <div className="osb-v3-retrieve-access-code-view">
            <RetrieveAccessCode />
        </div>
    );
}
